import React, { Component } from 'react';
import { reduxForm }        from 'redux-form';
import CSSModules from 'react-css-modules';

import InputGroup    from '../InputGroup';
import InputSection  from '../InputSection';
import Button        from '../Button';
import Input         from '../Input';
import Label         from '../Label';
import InlineError from "../InlineError";
import SelectBox from "../SelectBox";
import SearchTraining from '../SearchTraining';
import Checkbox      from '../Checkbox';

import AlertBox from "pattern-library/dist/js/components/AlertBox";
import RheIcon from "pattern-library/dist/js/components/RheIcon";

import * as marketingAdActions from '../../actions/marketingAd';

import style from './style.scss';

class MarketingPageAdForm extends Component {
    componentDidMount() {
        if (this.props.isLoading) {
            this.props.getAd();
        }
    }

    _generateUrl(item) {
        if ("name" in item) { // then we have a course
            return `/courses/${ item.id }/${ item.slug }`;
        } else { // we have an event
            return `/events/${ item.id }/${ item.course.slug }`;
        }
    }

    render() {
        const {
            fields: {
                title, sub_title, description, url, icon, is_visible
            },
            handleSubmit,
            updateAd,
            isShowingSuccess,
            setShowSuccessMessage,
            formErrors
        } = this.props;

        return (
            <div>
                {isShowingSuccess && (
                    <AlertBox className={style['marketing_success_close']} theme="success">
                        Marketing banner successfully updated. <RheIcon icon="cross" onClick={() => setShowSuccessMessage(false)} backgroundColour="green" />
                    </AlertBox>
                )}

                <form onSubmit={ handleSubmit(updateAd) }>
                    <InputSection>
                        <InputGroup>
                            <Checkbox { ...is_visible } errors={ is_visible.error } />
                            <Label>Show Banner</Label>
                            <InlineError errors={ is_visible.error } />
                        </InputGroup>

                        {this.props.values.is_visible && (
                            <div>
                                <InputGroup>
                                    <Label>Title</Label>
                                    <Input {...title} errors={formErrors.title} />
                                    <InlineError errors={formErrors.title} />
                                </InputGroup>

                                <InputGroup>
                                    <Label>Sub Title</Label>
                                    <Input {...sub_title} errors={formErrors.sub_title} />
                                    <InlineError errors={formErrors.sub_title} />
                                </InputGroup>

                                <InputGroup>
                                    <Label>Description</Label>
                                    <Input {...description} errors={formErrors.description} />
                                    <InlineError errors={formErrors.description} />
                                </InputGroup>

                                <InputGroup>
                                    <Label>Icon</Label>
                                    <SelectBox {...icon} errors={formErrors.icon}>
                                        <option value="elearning">E-learning</option>
                                        <option value="conference">Conference</option>
                                        <option value="course">Course</option>
                                        <option value="webinar">Webinar</option>
                                    </SelectBox>
                                    <InlineError errors={formErrors.icon} />
                                </InputGroup>

                                <InputGroup>
                                    <SearchTraining
                                        label="Link To"
                                        placeholder="Search for events, courses and webinars to link to."
                                        onSelectResult={result => this.props.fields.url.onChange(this._generateUrl(result))}
                                    />
                                </InputGroup>

                                <InputGroup>
                                    <Label>Currently active course url:</Label>
                                    <Input
                                        {...url}
                                        disabled
                                    />
                                </InputGroup>
                            </div>
                        )}

                        <InputGroup>
                            <Button>
                                <span>Update</span>
                            </Button>
                        </InputGroup>
                    </InputSection>
                </form>
            </div>
        )
    }
}

const reduxFormParams = {
    form: 'marketing-ad',
    fields: ['title', 'sub_title', 'description', 'url', 'icon', 'is_visible']
};

const mapStateToProps = state => {
    return {
        initialValues: state.marketingAd.ad,
        isLoading: state.marketingAd.loading,
        isShowingSuccess: state.marketingAd.isShowingSuccess,
        formErrors: state.marketingAd.errors
    }
}

const mapDispatchToProps = dispatch => {
    return {
        getAd: () => dispatch(marketingAdActions.getAd()),
        updateAd: params => dispatch(marketingAdActions.updateAd(params)),
        setShowSuccessMessage: isShowingSuccess => dispatch(marketingAdActions.setShowSuccessMessage(isShowingSuccess))
    }
}

export default reduxForm(reduxFormParams, mapStateToProps, mapDispatchToProps)(CSSModules(MarketingPageAdForm, style));


// WEBPACK FOOTER //
// ./components/MarketingPageAdForm/index.js